import React, {useState} from 'react';
import Modal from "./Modal";
import {useMediaQuery} from "beautiful-react-hooks";

const Infotip = (props) => {
    const isTablet = useMediaQuery('(max-width: 1023px)');

    const [show, setShow] = useState(false);

    const handleModalVisibility = () => {
        setShow(!show);
    };

    return (
        isTablet ?
            <div className="infotip">
                <div className="infotip__icon" onClick={handleModalVisibility}/>

                <Modal close={handleModalVisibility} show={show} additionalClass="infotip__modal">
                    <div className="infotip__icon infotip__icon--round" />
                    {props.children}
                </Modal>
            </div>
        :
            props.children
    );
}

export default Infotip;



// WEBPACK FOOTER //
// ./sources/js/components/global/Infotip.js